import { Alert, Button } from "@mui/material"

/**
 * Shown instead of the assignment board when something it needs failed to load (FIQ-2457),
 * so a failure is never mistaken for an empty list or left spinning.
 */
export function BoardLoadError({ message, onRetry, ...props }) {
    return (
        <Alert
            severity="error"
            action={
                <Button color="inherit" size="small" onClick={onRetry}>
                    Retry
                </Button>
            }
            {...props}
        >
            {message}
        </Alert>
    )
}
